import get from 'lodash/get';
import isObject from 'lodash/isObject';
import { insertReflexiveQuestions } from '../../utils';

export const test = '';

export const getContinueState = (state, sectionIndex, currentBreadcrumbId) => {
	const { questions } = state;
	const currentSection = questions.sections[currentBreadcrumbId];
	if (currentSection && currentSection.length) {
		const currentQuestions = currentSection[sectionIndex];
		if (!currentQuestions) {
			return {
				enableContinue: false,
				completed: false,
			};
		}
		const { enableContinue, completed } = currentQuestions;
		return {
			enableContinue,
			completed,
		};
	}
	return {
		enableContinue: false,
		completed: false,
	};
};

export const getPopupQuestions = (state) => {
	const { questions } = state;
	return get(questions, 'popupQuestions', []);
}

/** Same as ListQuestionCard row → insertReflexiveQuestions (per visible branch). */
const listRowToFlattenedQuestions = (rowObj) => {
	if (!rowObj || !isObject(rowObj)) {
		return [];
	}
	const asArray = Object.keys(rowObj).reduce((acc, key) => {
		if (isObject(rowObj[key])) {
			acc.push(rowObj[key]);
		}
		return acc;
	}, []);
	return insertReflexiveQuestions(asArray);
};

/** Truthy when answer counts as filled (primitives, select {id}, date parts, etc.). */
const answerSatisfiesListUpdate = (answer) => {
	if (answer === 0 || answer === false) {
		return true;
	}
	if (answer == null || answer === '') {
		return false;
	}
	if (typeof answer === 'string' && answer.trim() === '') {
		return false;
	}
	if (typeof answer === 'object') {
		if (Object.prototype.hasOwnProperty.call(answer, 'id') && answer.id !== '' && answer.id != null) {
			return true;
		}
		if (Object.prototype.hasOwnProperty.call(answer, 'day')
			|| Object.prototype.hasOwnProperty.call(answer, 'month')
			|| Object.prototype.hasOwnProperty.call(answer, 'year')) {
			return true;
		}
		return Object.keys(answer).length > 0;
	}
	return Boolean(answer);
};

/**
 * @param {object|null|undefined} listEditContext Optional. When set as { listQuestionRoot, rowIndex },
 *   questionIds is ignored and required ids come from that row only (list Update). Otherwise unchanged Add behavior.
 */
export const getEnableAdd = (state, sectionIndex, currentBreadcrumbId, questionIds, listEditContext) => {
	const { questions } = state;
	const currentSection = questions.sections[currentBreadcrumbId];
	if (!currentSection) {
		return false;
	}
	const currentQuestions = currentSection[sectionIndex];
	const { answersArray, errorsArray } = currentQuestions;

	let ids = questionIds;
	let listParentId;
	let rowIndex;
	const useListRow = listEditContext && listEditContext.listQuestionRoot != null
		&& Number.isInteger(listEditContext.rowIndex) && listEditContext.rowIndex >= 0;
	if (useListRow) {
		const listQuestionRoot = listEditContext.listQuestionRoot;
		rowIndex = listEditContext.rowIndex;
		listParentId = listQuestionRoot.question_id;
		const rows = listQuestionRoot.questions;
		if (!Array.isArray(rows) || rowIndex >= rows.length) {
			return false;
		}
		const flatQs = listRowToFlattenedQuestions(rows[rowIndex]);
		ids = flatQs
			.filter((q) => get(q, 'validations.required.value', false) && !get(q, 'is_hidden', false))
			.map((q) => q.question_id);
	}

	if (ids == null) {
		return false;
	}
	const blockingErrors = errorsArray.filter(
		(err) => err.isError && ids.includes(err.question_id),
	);
	if (!ids.length) {
		return !errorsArray.some((err) => err.isError);
	}
	if (blockingErrors.length) {
		return false;
	}

	return ids.every((id) => answersArray.some((ans) => {
		if (ans.question_id !== id) {
			return false;
		}
		if (useListRow) {
			if (ans.listParentId && ans.listParentId !== listParentId) {
				return false;
			}
			if (Number.isInteger(ans.listIndex) && ans.listIndex >= 0 && ans.listIndex !== rowIndex) {
				return false;
			}
		}
		return answerSatisfiesListUpdate(ans.answer);
	}));
};

export const getLoaders = (state) => {
  const { questions } = state;
  const { loadingSection, isLoading } = questions;
  return { loadingSection, isLoading };
}

export const getEnableContinueBreadCrumb = (state, currentBreadcrumbId, mode) => {
  if(mode === 'listEdit'){
	  return false;
  }
  const { questions, nList } = state;
  const { requiredSchema, enableAdd } = nList;
  const currentSection = questions.sections[currentBreadcrumbId];
  const enableContinue = currentSection && currentSection.reduce((acc, section) => acc && section.enableContinue, true)  
  if (requiredSchema.length) {
	return enableAdd && enableContinue
  }
  return enableContinue;
}
